module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-10-ddcc5ac3e97442bb463472457d440ee6.jpg";